import React from 'react';
import PropTypes from 'prop-types';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';
import PlanInformation from './plan_information';
import { getPlanTypeLabel } from 'bundles/backoffice/helpers/plans';

export const totalCommissionCalculationModes = [
  'use_total_gross_commission',
  'use_total_split_commission',
];

export default function PlanCalculationMode({ disabled, enabledRealCalculationModes, plan, onChange, ...props }) {
  if (!enabledRealCalculationModes || enabledRealCalculationModes.length <= 1) {
    return null;
  }

  const options = [];
  for (const mode of enabledRealCalculationModes) {
    options.push({ value: mode, label: getPlanTypeLabel(mode) });
  }

  function handleChange(realCalculationMode) {
    const changes = { realCalculationMode };
    if (totalCommissionCalculationModes.includes(realCalculationMode)) {
      changes.forCohort = false;
    }

    onChange(changes);
  }

  return (
    <div className="d-flex align-items-center mb-2">
      <ManagedFormGroup
        className="mb-0"
        disabled={disabled}
        label="Type"
        name="realCalculationMode"
        required
        type="select"
        value={plan.realCalculationMode}
        onValueChange={handleChange}
        {...props}
      >
        <option value="">Select a plan type...</option>
        <Options options={options} />
      </ManagedFormGroup>

      <PlanInformation />
    </div>
  );
}

PlanCalculationMode.propTypes = {
  disabled: PropTypes.bool,
  enabledRealCalculationModes: PropTypes.array,
  plan: PropTypes.shape({
    realCalculationMode: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
